module.exports = __webpack_public_path__ + "fonts/nucleo-icons.42643978.woff2";